import React, { FunctionComponent, ReactNode } from 'react';

import { StandardButton, ButtonLooks, ButtonSizes } from '@brandfolder/react';

export interface CustomFieldsRowDeleteProps {
  children?: ReactNode;
  loading: boolean;
  onCancel: () => void;
  onSubmit: () => void;
}

export const CustomFieldsRowDelete: FunctionComponent<CustomFieldsRowDeleteProps> = ({
  children,
  loading,
  onCancel,
  onSubmit,
}) => {
  const handleCancel = (): void => {
    onCancel();
  };

  const handleSubmit = (): void => {
    onSubmit();
  };

  return (
    <>
      <div className="delete-custom-fields-mode">
        &nbsp; {/* Placeholder for spacing */}
      </div>
      <div className="delete-custom-fields-mode overlay">
        {children}
        <div className="delete-buttons">
          {!loading && (
            <StandardButton
              className="delete-key-button"
              look={ButtonLooks.Tertiary}
              onClick={handleCancel}
              size={ButtonSizes.Medium}
            >
              {bfTranslate('Cancel')}
            </StandardButton>
          )}
          <StandardButton
            disabled={loading}
            loading={loading}
            look={ButtonLooks.Danger}
            onClick={handleSubmit}
            size={ButtonSizes.Medium}
          >
            {bfTranslate('Delete key')}
          </StandardButton>
        </div>
      </div>
    </>
  );
};
